import { TRACKED_PRODUCT_STATUS_EXTRA, TRACKED_PRODUCT_STATUS_MISSING, TRACKED_PRODUCT_STATUS_FOUND } from './../components/inventory/scan-rack/edit/edit.const';
import Model from './Model';
import * as _ from 'lodash';
import { FETCH_EXTRA_PRODUCT_SUCCEEDED } from '../components/inventory/scan-rack/edit/edit.actions';

interface ProductTrack {
  status: Number;
  product_id: Number;
  track_id: Number;
  isExtra(): Boolean;
  isMissing(): Boolean;
  isFound(): Boolean;
}

class ProductTrack extends Model implements ProductTrack {
  constructor(options) {
    super();

    this.bind(options);
  }

  isExtra() {
    return this.status === TRACKED_PRODUCT_STATUS_EXTRA;
  }

  isMissing() {
    return this.status === TRACKED_PRODUCT_STATUS_MISSING;
  }

  isFound() {
    return this.status === TRACKED_PRODUCT_STATUS_FOUND;
  }
}

export default ProductTrack;
